import { computed, ref, useRoute, watch } from "@nuxtjs/composition-api";

import { useTranslate } from "./translations";

const getRandomValueWithoutRepeating = (array: string[], previousValue: string | null) => {
  let newValue: string;
  do {
    newValue = array[Math.floor(Math.random() * array.length)];
  } while (newValue === previousValue);
  return newValue;
};

export const useRotatingSearchSuggestions = () => {
  const route = useRoute();
  const { t } = useTranslate();

  // A list of example semantic search prompt suggestions.
  const rotatingSuggestions = computed(() => [
    t("Wedding dresses").value,
    t("Breathable sandals for summer").value,
    t("Summer outfits for pool").value,
    t("Summer dresses").value,
    t("Athleisure outfits for errands").value,
    t("Yoga sets").value,
    t("Summer skincare").value,
    t("Front porch & patio style inspo").value,
    t("Patio decor").value,
    t("Maternity looks for travel").value,
    t("Baby shower").value,
    t("Country concert outfits with boots").value,
    t("Vanity setup ideas with storage").value,
    t("Bathroom organization ideas").value,
    t("Bridal shower outfits for guests").value,
    t("Summer weddings").value,
    t("Vacation looks for Disney cruise").value,
    t("Vacation outfits").value,
    t("Plus size").value,
    t("Petite-friendly summer outfits").value,
    t("Kitchen decor for warm seasons").value,
    t("Office outfits for warmer weather").value,
    t("Concert outfits").value,
    t("Walking outfits for sunny days").value,
    t("Workout sets").value,
    t("Coffee tables for small spaces").value,
    t("Living room").value,
    t("Nursery decor for boys").value,
    t("Organize your bathroom space").value,
    t("Top-rated self tanners").value,
    t("Summer wedding guest dresses").value,
    t("Bridal shower outfits for guests").value,
    t("Travel outfits for flights").value,
    t("Beach outfits").value,
    t("Fourth of July family outfits").value,
    t("Comfortable postpartum outfits").value,
    t("Summer shoes").value,
    t("Everyday style ideas for men").value,
    t("Kitchen runner and decor ideas").value,
    t("Work from home outfit ideas").value,
    t("Casual outfits").value,
    t("Plus size outfits for the beach").value,
    t("Living room rug refresh ideas").value,
    t("Outdoor rugs").value,
    t("Toddler outfits").value,
    t("Best bras for everyday wear").value,
    t("Self tanner").value,
    t("Black tie outfits for weddings").value,
    t("Outdoor weddings").value,
    t("Airport outfits for long flights").value,
    t("Vacation shoes").value,
    t("Summer dresses for beach trips").value,
    t("Pool party looks").value,
    t("Postpartum outfit ideas for moms").value,
    t("Midsize fashion").value,
    t("Coffee bar setup at home").value,
    t("Amazon outfits for every day").value,
    t("Date night").value,
    t("Loungewear sets for rest days").value,
    t("Sneakers").value,
    t("Rugs to update your living room").value,
    t("Dining room").value,
    t("Mom style").value,
    t("Affordable beauty finds on Amazon").value,
    t("Makeup favorites").value,
    t("Beach wedding guest outfit ideas").value,
    t("Wedding accessories").value,
    t("Europe summer outfit inspiration").value,
    t("Packing list").value,
    t("Fourth of July outfit inspo").value,
    t("Summer travel outfits").value,
    t("Plus size resort wear ideas").value,
    t("Bump friendly").value,
    t("Dining chairs for summer hosting").value,
    t("Concert outfits for summer festivals").value,
    t("Maxi dresses").value,
    t("Athletic dress").value,
    t("Decor ideas for guest bedrooms").value,
    t("Guest bedroom").value,
    t("Body care").value,
    t("Formal dresses for summer weddings").value,
    t("Guest dresses").value,
    t("Cruise outfits for women").value,
    t("Comfy travel wear").value,
    t("Summer-ready work outfit ideas").value,
    t("Summer bags").value,
    t("Plus size beach cover ups").value,
    t("Curvy style").value,
    t("Stylish kitchen storage ideas").value,
    t("Summer skirts").value,
    t("Rest day looks").value,
    t("Wall art to elevate your space").value,
    t("Kitchen decor").value,
    t("Hair accessories").value,
    t("Mother of the bride dress ideas").value,
    t("Luggage & travel essentials").value,
    t("Tall fashion").value,
    t("Outdoor dining setup ideas").value,
    t("Amazon fashion").value,
    t("Amazon finds for small apartments").value,
    t("Porch refresh").value,
    t("Summer skincare").value,
    t("Beach bags & vacation must-haves").value,
    t("Summer tops").value,
    t("Nursery decor").value,
    t("Shower essentials").value,
    t("Comfortable travel sets for flights").value,
    t("Mini dresses").value,
    t("Console tables").value,
    t("What to wear on a cruise").value,
    t("Wellness gear for home workouts").value,
    t("Fitness-friendly travel outfits").value,
    t("Hair accessories").value,
    t("Shower essentials").value,
  ]);

  const currentSuggestion = ref(getRandomValueWithoutRepeating(rotatingSuggestions.value, null));

  watch(route, (to, from) => {
    if (to.path === from.path) {
      return;
    }
    currentSuggestion.value = getRandomValueWithoutRepeating(rotatingSuggestions.value, currentSuggestion.value);
  });

  return {
    currentSuggestion,
  };
};
